import { render, staticRenderFns } from "./InStore.vue?vue&type=template&id=22a881a8&scoped=true&"
import script from "./InStore.vue?vue&type=script&lang=js&"
export * from "./InStore.vue?vue&type=script&lang=js&"
import style0 from "./InStore.vue?vue&type=style&index=0&id=22a881a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a881a8",
  null
  
)

export default component.exports